import { calc } from '../../api/calc';
import { BrowserFourdApi } from './index';

export class Calc implements calc.Api {
  constructor(private fourd: BrowserFourdApi) {}

  evaluatePaths(request: calc.EvaluatePathsRequest): Promise<calc.PathResult[]> {
    return this.fourd.twoWayCall<calc.EvaluatePathsRequest, calc.PathResult[]>(
      request,
      (requestId, request) => {
        const calcRequest = {
          method: 'POST',
          url: '/api/evaluate/paths',
          body: request,
        };
        this.fourd.call4Dv2('calc.evaluatePaths', calcRequest, requestId);
      },
      (response) => {
        if (response.status >= 400) {
          throw new Error(JSON.parse(response.body).message);
        } else {
          let responseData;
          try {
            responseData = JSON.parse(response.body);
          } catch (e) {
            // Unable to parse response.body => response.body is not a stringify object
            responseData = response.body;
          }
          return responseData;
        }
      }
    );
  }
}
